import { constants } from 'appConstants';
const {
  links: { affiliateLink, aboutLink, doDontsLink, FaqLink, supportLink },
} = constants;

const careersLink = 'https://www.ltvco.com/careers/';
const upgradePlanLink = 'https://forms.gle/DQRkuCEfgFBL3Fqf7';

export const generateFooterLinks = ({
  contactUsHandler,
}: {
  contactUsHandler: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}) => [
  {
    title: 'RESOURCES',
    links: [
      { text: 'Affiliates', href: affiliateLink },
      {
        text: 'Need More Reports?',
        href: upgradePlanLink,
      },
    ],
  },
  {
    title: 'SUPPORT',
    links: [
      { text: 'Customer Care', href: supportLink },
      { text: 'Contact Us', href: '#', onClick: contactUsHandler },
      { text: "Do's & Dont's", href: doDontsLink },
      { text: "FAQ's", href: FaqLink },
    ],
  },
  {
    title: 'COMPANY',
    links: [
      { text: 'About PeopleSmart', href: aboutLink },
      { text: 'Careers', href: careersLink },
    ],
  },
];
